<template>
  <div class="news-list">
    <div v-if="hasValue" style="overflow:auto">
      <div v-for="(item, i) in data" :key="i" class="news-item">
        <div class="news-item-header">
          <div class="news-item-title">
            <img :src="pdfImg" />
            <router-link :to="`/industry/detail/${item.newsId}`">
              {{ item.title }}
            </router-link>
          </div>
          <div class="news-item-tool">
            <el-button v-if="!editable" type="text" @click.stop="collect(item)"
              >收藏</el-button
            >
            <el-button v-if="!editable" type="text" @click.stop="download(item)"
              >下载</el-button
            >
            <el-button v-if="editable" type="text" @click.stop="remove(item)"
              >删除</el-button
            >
            <el-button
              v-if="editable && item.state == 1"
              type="text"
              @click.stop="publish(item)"
              >发布</el-button
            >
            <!-- <el-button v-if="editable && item.state == 2" type="text" @click.stop="unPublish(item)"
              >取消发布</el-button
            >  -->
          </div>
        </div>
        <div class="news-item-desc">{{ item.introduction }}</div>
        <div class="news-item-footer">
          <div>
            发布日期：{{ $moment(item.timestamp).format('YYYY-MM-DD') }}
          </div>
          <div>来源：{{ item.source }}</div>
        </div>
      </div>
    </div>
    <div v-else class="empty">暂无数据</div>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { getToken } from '@/utils/index';

export default {
  props: ['data', 'editable'],
  computed: {
    hasValue() {
      return !isEmpty(this.data);
    }
  },
  data() {
    return {
      pdfImg: require('@/asset/pdf.png')
    };
  },
  methods: {
    async collect(item) {
      await this.$postForm({
        url: '/windfarm/news/industryCollection',
        data: { newsId: item.newsId },
        showLoading: true,
        showSuccess: true,
        showError: true
      });
      this.$emit('collect');
    },
    download(item) {
      window.open(
        `${process.env.VUE_APP_API_HOST}/windfarm/news/downloadFile?newsId=${
          item.newsId
        }&apiKey=${getToken()}`
      );
    },
    async remove(item) {
      await this.$postForm({
        url: '/windfarm/news/deleteIndustryDynamic',
        data: { newsId: item.newsId },
        showLoading: true,
        showSuccess: true,
        showError: true
      });
      this.$emit('refresh');
    },
    async publish(item) {
      await this.$postForm({
        url: '/windfarm/news/industryDynamicRelease',
        data: { newsId: item.newsId },
        showLoading: true,
        showSuccess: true,
        showError: true
      });
      this.$emit('refresh');
      this.$emit('collect');
    },
    async unPublish(item) {
      await this.$postForm({
        url: '/windfarm/news/industryDynamicRelease',
        data: { newsId: item.newsId },
        showLoading: true,
        showSuccess: true,
        showError: true
      });
      this.$emit('refresh');
    }
  }
};
</script>

<style lang="less" scoped>
.news-list {
  margin-top: 5px;

  .empty {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(50%);
    font-size: 14px;
    color: #8f9197;
  }

  .news-item {
    font-size: 12px;
    margin: 12px 0;
    padding: 20px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .news-item-header {
      display: flex;

      .news-item-title {
        flex: 1;
        display: flex;
        font-size: 18px;
        color: #003e8e;
        text-decoration: underline;
        font-weight: bold;
        height: 23px;
        line-height: 23px;

        img {
          display: block;
          margin-right: 10px;
        }
      }

      /deep/.news-item-tool {
        .el-button {
          padding: 0px;
          font-size: 15px;
          &.el-button--text {
            color: #3271a1;
          }
        }
      }
    }
    .news-item-desc {
      font-size: 14px;
      margin: 10px 0;
    }

    .news-item-footer {
      display: flex;
      color: #525252;
      margin: 10px 0;

      > div {
        margin-right: 20px;
      }
    }
  }
}
</style>
